import BaseBox from './BaseBox.jsx';

export default BaseBox;
